import _esMap from "../modules/es.map.constructor";
// TODO: Remove this module from `core-js@4` since it's replaced to module below
_esMap;
export default {};